import {useMutation} from '@tanstack/react-query';
import utils from '../helpers/utils';
import {fetchRest} from '../helpers/fetchRest';

/**
 * Custom hook for managing Quebec reimbursement opt-in functionality
 * @returns Object with setOptInConsent function and mutation data
 */
export const useQuebecOptIn = () => {
  /**
   * Submit Quebec opt-in consent
   * @param {boolean} consent - true if user opts in, false if opts out
   * @returns {Promise} - Promise that resolves to the API response
   */
  const submitOptInConsent = async(consent: boolean) => {
    const url = utils.getQuebecOptInPath();
    const response = await fetchRest(url, {
      method: 'POST',
      body: JSON.stringify({
        consent: consent,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    return response;
  };

  const {
    mutate: setOptInConsent,
    isPending: isLoading,
    isError,
    error,
    isSuccess,
    data,
  } = useMutation({
    mutationKey: ['quebecOptInConsent'],
    mutationFn: submitOptInConsent,
  });

  return {
    setOptInConsent,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
  };
};
